import React from 'react';
import PropTypes from 'prop-types';
import { rem } from 'polished';

import styled from 'styled-components';

import Image from '../Image';
import Link from '../Link';

import { breakpoint } from '../../theme';

const Root = styled.div`
  display: flex;
  flex-direction: column;
  padding: 1rem 0;
  background-color: ${(props) => props.theme.palette.background.content};
  border-radius: 15px;
  height: 100%;
  width: 100%;

  &:hover {
    background-color: ${(props) => props.theme.palette.background.primary};
  }
`;

const Thumbnail = styled.div`
  margin: auto;
  width: 71%;
`;

const Title = styled.h4`
  margin-top: 1rem;
  color: ${({ theme }) => theme.palette.text.primary};
  font-size: ${rem(14)};

  ${breakpoint('smallmedium')} {
    font-size: ${rem(16)};
  }

  ${breakpoint('medium')} {
    font-size: ${rem(16)};
  }

  ${breakpoint('mediumlarge')} {
    font-size: ${rem(15)};
  }

  ${breakpoint('large')} {
    font-size: ${rem(16)};
  }
`;

const SubTitle = styled.h5`
  margin-top: 0rem;
  color: ${({ theme }) => theme.palette.colors.greyLight};
  font-size: ${rem(12)};

  ${breakpoint('smallmedium')} {
    font-size: ${rem(13)};
  }

  ${breakpoint('medium')} {
    font-size: ${rem(13)};
  }

  ${breakpoint('mediumlarge')} {
    font-size: ${rem(12)};
  }

  ${breakpoint('large')} {
    font-size: ${rem(13)};
  }
`;

const Content = styled.div`
  width: 100%;
  padding: 0 1rem;
`;

const ThumbnailPlaceholder = styled.div`
  display: block;
  width: 100%;
  padding-bottom: 100%;
  background-color: ${(props) => props.theme.palette.colors.grey};
`;

function GridItem(props) {
  const { title, image, link, subTitle } = props;

  return (
    <Root to={link} as={link ? Link : null}>
      <Thumbnail>
        {image?.childImageSharp ? (
          <Image fluid={image.childImageSharp.fluid} alt={`${title}`} />
        ) : (
          <ThumbnailPlaceholder />
        )}
      </Thumbnail>
      <Content>
        <Title>{title}</Title>
        {subTitle && <SubTitle>{subTitle}</SubTitle>}
      </Content>
    </Root>
  );
}

GridItem.propTypes = {
  title: PropTypes.node.isRequired,
  subTitle: PropTypes.node,
  image: PropTypes.shape({
    childImageSharp: PropTypes.objectOf(PropTypes.object),
    source_url: PropTypes.string,
    alt_text: PropTypes.string,
    title: PropTypes.string,
  }),
  link: PropTypes.string.isRequired,
};

GridItem.defaultProps = {
  image: null,
  subTitle: undefined,
};

export default GridItem;
